/*
 * Copyright (c) 2022. Haodong JU
 */

import IKUtils from 'innerken-js-utils'
import i18n from '@/i18n'

export function emptyOrIncludes (arr, item) {
  return arr.length === 0 || arr.includes(item)
}

export function searchData (data, word, key) {
  return data.filter(d => {
    if (!word) {
      return true
    } else {
      const words = word.split(' ')
      return words.every(w => d[key].toLowerCase().includes(w))
    }
  })
}

export function wordContainsIn (word, text) {
  if (!word) {
    return true
  } else {
    const words = word.toLowerCase().split(' ')
    return words.every(w => text.toLowerCase().includes(w))
  }
}

export const Rules = {
  required: value => !!value || 'Required.',
  counter: value => value.length <= 20 || 'Max 20 characters',
  email: value => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return pattern.test(value) || 'Invalid e-mail.'
  },
  ip: value => {
    return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(value) || this.$t('pls_input_suitable_IP')
  },
}

/**
 *
 * @param action
 * @param {string} title
 * @param {string} content
 * @returns {Promise<void>}
 */
export async function sureTo (action, content = '', title = i18n.t('are_you_sure')) {
  const res = await IKUtils.showConfirmAsyn(i18n.t(content), i18n.t(title))
  IKUtils.showLoading(true)
  if (res.isConfirmed) {
    await action()
  } else {
    IKUtils.toast(i18n.t('cancel_success'), 'info')
  }
}
export async function sureToDelete (action, content = '', title = i18n.t('are_you_sure_to_delete') + '?') {
  const res = await IKUtils.showConfirmAsyn(i18n.t(content), i18n.t(title))
  IKUtils.showLoading(true)
  if (res.isConfirmed) {
    await action()
    IKUtils.toast(i18n.t('delete_success'), 'success')
  } else {
    IKUtils.toast(i18n.t('cancel_success'), 'info')
  }
}

export function findLangEntityInLangArr (lang, arr) {
  return arr.find(d => d.lang.toLowerCase() === lang.toLowerCase()) ?? null
}

export function copyToAll (field, arr) {
  const [de, zh, en] = [findLangEntityInLangArr('DE', arr), findLangEntityInLangArr('ZH', arr), findLangEntityInLangArr('EN', arr)]

  for (const fieldKey of field.childKey) {
    const [deContent, zhContent, enContent] = [de, zh, en].map(it => it[fieldKey])
    const target = deContent || zhContent || enContent

    const empty = [de, zh, en].filter(it => !it[fieldKey])
    for (const key of empty) {
      key[fieldKey] = target
    }
  }
}

export function showSuccessMessage (title) {
  IKUtils.toast(title, 'success')
}
